import { atom } from 'recoil';
import { defineds } from '@storybook/date-range-picker/defineds';

import type { IDateRange } from 'global-stores/date-picker/type';

const { startOfLast30days, endOfLast30days } = defineds;

/**
 * A page of its own, not a share of Sessions' SelectedDateRangeState — the two
 * pages filtering the same calendar range by accident is not a feature, and
 * SelectedActivityDateRangeState already established the "give a distinct
 * filter surface its own atom" precedent in this codebase.
 */
export const SelectedSentDateRangeState = atom<IDateRange[]>({
	key: 'selected-sent-date-range-state',
	default: [
		{
			startDate: startOfLast30days,
			endDate: endOfLast30days,
			key: 'selection',
		},
	],
});
